import {evite} from 'evite';
import {ID_PREFIX_BY_CONFIG_KEY} from '~/ads/constants';
import {getAdDimensions} from '~/ads/utils';

interface GetAdConfigParams {
  index: number;
  isLargishAndUp: boolean;
  configKey: 'topLeaderboard' | 'leaderboard' | 'sidePanel' | 'photoShare' | 'photoShareGallery';
  location: string;
}

export const getAdConfig = ({index, isLargishAndUp, configKey, location}: GetAdConfigParams) => {
    const {dfp} = evite;
    const sidePanel = configKey === 'sidePanel';
    const GoogleBannerAdIdWithIndex = `${ID_PREFIX_BY_CONFIG_KEY[configKey]}${index ? `-${index}` : ''}`;
    const adUnitId = isLargishAndUp || sidePanel ? dfp.DESKTOP_ID : dfp.MOBILE_ID;
    const firstSlot = isLargishAndUp || sidePanel ? dfp.DESKTOP_SLOT_1 : dfp.MOBILE_SLOT_1;
    const secondSlot = isLargishAndUp || sidePanel ? dfp.DESKTOP_SLOT_2 : dfp.MOBILE_SLOT_2;
    const adSlotUrl = dfp.compactUrl(adUnitId, firstSlot, secondSlot, GoogleBannerAdIdWithIndex);

    const dimensions = getAdDimensions(configKey, isLargishAndUp);
    return {
        GoogleBannerAdIdWithIndex,
        adSlotUrl,
        dimensions,
        location,
    };
};
